import React, {useEffect} from 'react';
import { Routes, Route, BrowserRouter,  } from 'react-router-dom';
import LogIn from './containers/log_in';
import Nav from './components/nav';
import { agent_log_in, client_agent } from './service/user';
import {cookie, getCookie, expire_cookie} from './utils/shared';

import { agent_permission_lookup } from './service/agents';

import Home from './containers/home'
import Bookings from './containers/bookings'
import BookingView from './containers/booking_view';

import Basket from './containers/baskets';
import BaskeView from './containers/basket_view';

import Promos from './containers/promos';
import PromoAdd from './containers/promo_add';

import OfferLinks from './containers/offers/links'
import OfferAdd from './containers/offers/links_add'

import '../src/App.css';

class App extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        user_id: 0,
        role_id: 0,
        user_logged_in: false,
        two_challenge: false,
        user_name: null,
        user_token: '',
        log_in_attempts: 0,
        log_in_err: false,
        menu_links: [{'url': '/', 'name': 'Home', 'new': false}, {'url': '/bookings', 'name': 'Bookings', 'new': false},{'url': '/baskets', 'name': 'Customer Reference', 'new': false}, {'url': '/offers', 'name': 'Share Offers', 'new': false}]
      };
    }

    
    componentDidMount(){
      let uli_tk = getCookie('agt_usign',true);

      window.setInterval(() => {

        if(uli_tk != null){
          client_agent().then((d) => {
            if(d == null){
              expire_cookie("agt_usign")
              this.setState({user_logged_in: false, user_token: ''});
              window.location = '/';
            }
            else{
              if(d.data.client_agent.result == null){
                expire_cookie("agt_usign")
                this.setState({user_logged_in: false, user_token: ''});
                window.location = '/';
                return
              }
            }
          })
        }

      }, 30000)

      if(uli_tk != null){

        client_agent().then((d) => {


  

          if(d == null){
            expire_cookie("agt_usign")
            this.setState({user_logged_in: false, user_token: ''});
            window.location = '/';
          }
          else{

            if(d.data.client_agent.result == null){
              expire_cookie("agt_usign")
              this.setState({user_logged_in: false, user_token: ''});
              window.location = '/';
              return
            }

            let user_a_token = uli_tk['token'];
            this.setState({user_logged_in: true, user_token: user_a_token})

            agent_permission_lookup(user_a_token, 3).then((rd) => {
              if(rd.result){
                this.set_menu_links([{'url': '/', 'name': 'Home', 'new': false}, {'url': '/bookings', 'name': 'Bookings', 'new': false},{'url': '/baskets', 'name': 'Customer Reference', 'new': false},{'url': '/promos', 'name': 'Promo Codes', 'new': false}], {'url': '/offers', 'name': 'Share Offers', 'new': false})
              }
            })

          }
        })     
      }
    }

    log_in = async(user_name, password) =>{
      const {log_in_attempts} = this.state;
      agent_log_in(user_name, password).then((r) => {
         let la = 0;
         if(r == null){
            la = log_in_attempts + 1;
            this.setState({user_logged_in: false, log_in_err: true});
         }
         else{

            let cd = JSON.stringify(r)
            cookie('agt_usign', cd, false, 28);
            window.location = '/';
         }
      
      });
    }
    
    log_out = () => {
      cookie('agt_usign', null, false, -100);
      window.location = '/';
    }

    set_menu_links =(lnks) => {
      this.setState({menu_links: lnks})
    }

    access_auth = (req_role) => {
      // let uli_tk = getCookie('usign',true);
      // let role_id = uli_tk["role_id"];
      // if(role_id > req_role){
      //   window.location = '/';
      // }

      // let permissionpass = false


      // if(!permissionpass){
      //   window.location = '/';
      // }

      return true;

    }

    render() {

      const {user_logged_in, log_in_attempts, log_in_err} = this.state

      let log_in_message = null;
      if(log_in_attempts > 0){
        log_in_message = <div>Username / Password incorrect</div>
      }

      if(!user_logged_in){
        return(
          <div className='app' style={{width:'100%'}}>
            <BrowserRouter>
            <Routes>
                <Route path="/" element={<LogIn {...this.props} isError={log_in_err} log_in_func={(u, p) => this.log_in(u, p)} ></LogIn>} exact />
            </Routes>
            {log_in_message}
            </BrowserRouter>
          </div>
        )
    }


    return(
        <div className='app' style={{width:'100%'}}>

<BrowserRouter>
            <Nav user_token={this.state.user_token} usr_ref={this.state.sub_user_ref} links={this.state.menu_links} log_out_func={() => this.log_out()}></Nav>

              <Routes>

                {/* <Route path="/" element={<Bookings user_token={this.state.user_token} authorize={(x) => this.access_auth(x)} set_menu={(x) => this.set_menu_links(x)}></Bookings>} exact /> */}

                  <Route path="/" element={<Home user_token={this.state.user_token} set_menu={(x) => this.set_menu_links(x)}></Home>} exact />

                  <Route path="/bookings" element={<Bookings user_token={this.state.user_token} authorize={(x) => this.access_auth(x)} set_menu={(x) => this.set_menu_links(x)}></Bookings>} exact />
                  <Route path="/bookings/view" element={<BookingView user_token={this.state.user_token} authorize={(x) => this.access_auth(x)} set_menu={(x) => this.set_menu_links(x)}></BookingView>} exact />
                  
                  <Route path="/baskets" element={<Basket user_token={this.state.user_token} authorize={(x) => this.access_auth(x)} set_menu={(x) => this.set_menu_links(x)}></Basket>} exact />
                  <Route path="/basket/view" element={<BaskeView user_token={this.state.user_token} authorize={(x) => this.access_auth(x)} set_menu={(x) => this.set_menu_links(x)}></BaskeView>} exact />

                  <Route path="/promos" element={<Promos user_token={this.state.user_token} authorize={(x) => this.access_auth(x)} set_menu={(x) => this.set_menu_links(x)}></Promos>} exact />
                  <Route path="/promo/add" element={<PromoAdd user_token={this.state.user_token} authorize={(x) => this.access_auth(x)} set_menu={(x) => this.set_menu_links(x)}></PromoAdd>} exact />


                  <Route path="/offers" element={<OfferLinks user_token={this.state.user_token} authorize={(x) => this.access_auth(x)} set_menu={(x) => this.set_menu_links(x)}></OfferLinks>} exact />
                  <Route path="/offers/add" element={<OfferAdd user_token={this.state.user_token} authorize={(x) => this.access_auth(x)} set_menu={(x) => this.set_menu_links(x)}></OfferAdd>} exact />
                  
              </Routes>
            </BrowserRouter>

        </div>
    )

    }



}

export default App
